module.exports = __webpack_public_path__ + "img/promo-fertigen-bgr.3cda842e.svg";